/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Group Name" |
*
* @param {Team_Manager_Group_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_name_placeholder = /** @type {((inputs?: Team_Manager_Group_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppenname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("组名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループ名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do grupo")
	return /** @type {LocalizedString} */ ("Group Name")
});